import { inject, Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, of } from "rxjs";

import { environment } from "../../../../environments/environment";
import { SubmittersResponse } from "../models/submitter.model";

@Injectable({ providedIn: "root" })
export class SubmitterApiService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = `${environment.interactiveExperienceServiceUrl}/v1/submitters`;

    getSubmitters(submitterContactIds: string[]): Observable<SubmittersResponse> {
        if (!submitterContactIds.length) return of({ items: [] });

        let params = new HttpParams();
        submitterContactIds.forEach(id => (params = params.append("ids", id)));

        return this.http.get<SubmittersResponse>(this.baseUrl, { params });
    }
}
